import { getIconByContentType, getLessonItemImageCover, getLessonItemType } from 'core/utils/lessonItems';

// El endpoint V3 no envía items_jobs_completed (y envía items_jobs_total a 0 aunque haya jobs),
// así que lo calculamos desde los jobs con el mismo criterio de completado que useXapiResultsUsers
function countCompletedJobs(jobs) {
  return jobs?.filter((job) => job?.progress >= 1)?.length ?? 0;
}

export function validateLessonItem(lessonItem) {
  if (!lessonItem) {
    return {};
  }

  const didacticType = lessonItem?.didactic_types?.length > 0 ? lessonItem?.didactic_types[0] : null;

  // Determinar el status del lesson item
  let status = 'draft';
  if (lessonItem.status === 'scheduled') {
    status = 'scheduled';
  } else if (lessonItem.is_visible) {
    status = 'published';
  }
  return {
    ...lessonItem,
    guid: lessonItem.lesson_item_guid,
    lessonGuid: lessonItem.lesson_item_parent_guid,
    name: lessonItem.name,
    description: lessonItem.description,
    author_role_guid: lessonItem.author_role_guid,
    content_guid: lessonItem.content_guid,
    content_data: lessonItem.content_data,
    content_name: lessonItem.content_name || lessonItem.name,
    content_type_guid: lessonItem.content_type_guid,
    content_is_teacher_only: lessonItem.content_is_teacher_only,
    content_is_evaluable: lessonItem.content_is_evaluable,
    course_messages_guid: lessonItem.course_messages_guid,
    content_url: lessonItem.content_url,
    teacher_notes: lessonItem.teacher_notes,
    is_embed: lessonItem.is_embed === true ? 1 : 0,
    item_for: lessonItem.item_for,
    item_for_users: lessonItem.item_for_users,
    item_jobs_total: lessonItem.items_jobs_total || lessonItem.jobs?.length,
    item_jobs_completed: lessonItem.items_jobs_completed ?? countCompletedJobs(lessonItem.jobs),
    jobs: lessonItem.jobs,
    can_deliver_late: lessonItem.can_deliver_late === true ? 1 : 0,
    deliver_at: lessonItem.deliver_at,
    publish_score_at: lessonItem.publish_score_at,
    evaluation_scale: lessonItem.evaluation_scale,
    evaluation_category: lessonItem.evaluation_category,
    published_at: lessonItem.published_at,
    ranking_scale: lessonItem.ranking_scale ?? 10,
    is_visible: lessonItem.status,
    status: status,
    jobStatus: lessonItem?.job_status || 'pending',
    icon: didacticType?.icon ? didacticType.icon : getIconByContentType(lessonItem?.content_type_guid),
    image: getLessonItemImageCover(lessonItem?.content_type_guid, lessonItem?.deliver_at, lessonItem?.can_deliver_late),
    didacticTypeCover: didacticType?.thumbnail,
    didacticTypeName: didacticType?.name ?? null,
    type: getLessonItemType(lessonItem?.content_type_guid),
    session: lessonItem.session
      ? lessonItem.session.map((session) => ({
          session_order: session.session_order,
          session_resource_type: session.session_resource_type,
          session_id: session.session_id,
        }))
      : [],
    // AI metadata for AI-powered quiz generation (stored at outer level)
    ai_metadata: lessonItem.ai_metadata,
    // Map lesson_item_attachments from API response to attachments for component consumption
    attachments: lessonItem.lesson_item_attachments ?? [],
  };
}
